<template>
  <v-form>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <v-card>
      <HeaderDividerBlock
        :headerText="
          isEdit ? 'Edit Product Category' : 'Add New Product Category'
        "
      ></HeaderDividerBlock>

      <v-container class="pa-6">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Category Name</p>
            </v-col>
            <v-text-field
              v-model="form.name"
              placeholder="Enter Category Name"
              required
              outlined
              dense
            />
          </v-col>
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Category Code</p>
            </v-col>
            <v-text-field
              v-model="form.code"
              placeholder="Enter Category Code"
              required
              outlined
              dense
            />
          </v-col>
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Remarks</p>
            </v-col>
            <v-textarea
              v-model="form.remarks"
              placeholder="Enter Remarks"
              outlined
              dense
            />
          </v-col>
          <!-- <v-select
          v-model="form.status"
          :items="statuses"
          label="Status"
          outlined
          dense
        /> -->
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="submit"
          :disabled="!isFormValid || loading"
        >
          {{ isEdit ? "Update" : "Save" }}
        </v-btn>
        <v-btn text @click="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </v-form>
</template>

<script>
import { ProductCategoryService } from "@/services/productCategory-service";
import Alert from "@/components/shared/Alert.vue";
import Snackbars from "@/components/shared/Snackbars.vue";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";

export default {
  name: "productCategoryForm",
  components: { Alert, Snackbars, HeaderDividerBlock },
  props: {
    category: { type: Object, default: null },
  },
  data() {
    return {
      form: {
        name: "",
        code: "",
        remarks: "",
        status: "ACTIVE",
      },
      categoryUuid: null,
      statuses: ["ACTIVE", "INACTIVE"],
      loading: false,
      errors: null,
      snackbar: false,
      successMsg: "",
      isEdit: false,
    };
  },
  computed: {
    isFormValid() {
      return this.form.name && this.form.code && this.form.status;
    },
  },
  mounted() {
    if (this.category) {
      this.isEdit = true;
      this.categoryUuid = this.category.uuid;
      this.form = {
        name: this.category.name || "",
        code: this.category.code || "",
        remarks: this.category.remarks || "",
        status: this.category.status || "ACTIVE",
      };
    } else if (this.$route.params.uuid) {
      this.isEdit = true;
      this.loading = true;
      ProductCategoryService.getCategoryInfo(this.$route.params.uuid)
        .then((response) => {
          const cat = response.data.data;
          this.categoryUuid = cat.uuid;
          this.form = {
            name: cat.name || "",
            code: cat.code || "",
            remarks: cat.remarks || "",
            status: cat.status || "ACTIVE",
          };
        })
        .catch(() => {
          this.errors = ["Failed to load category info"];
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    async submit() {
      this.loading = true;
      this.errors = null;
      try {
        if (this.isEdit == true) {
          await ProductCategoryService.updateCategory(
            this.categoryUuid,
            this.form
          );
          this.successMsg = "Product category updated successfully!";
        } else {
          await ProductCategoryService.createCategory(this.form);
          this.successMsg = "Product category created successfully!";
        }
        this.snackbar = true;
        this.$emit("saved");
        setTimeout(() => {
          this.$router.push("/product-categories");
        }, 1100);
      } catch (error) {
        let data = error.response?.data?.error || "Unknown error";
        this.errors = [data];
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    onDismissed() {
      this.errors = null;
    },
  },
};
</script>
